import React, { useState, useRef, useEffect } from 'react';
import theme from '../../theme';

const ConfigPatch = ({ symbol, dynamic_patch, handleSetPatch }) => {
  const [localSymbol, setLocalSymbol] = useState(dynamic_patch?.local_symbol || '');
  const [multiplier, setMultiplier] = useState(dynamic_patch?.multiplier || '');
  const [isOpen, setIsOpen] = useState(Boolean(dynamic_patch?.active));
  const contentRef = useRef(null);

  const handleSave = (e) => {
    e.preventDefault();
    if (localSymbol !== '' || multiplier !== '' || dynamic_patch?.active) {
      handleSetPatch(!dynamic_patch?.active, localSymbol, multiplier);
    }
  };

  const [showSymbols, setShowSymbols] = React.useState(false);

  const contractMonths = {
    "January": 'F', "February": 'G', "March": 'H', "April": 'J',
    "May": 'K', "June": 'M', "July": 'N', "August": 'Q',
    "September": 'U', "October": 'V', "November": 'X', "December": 'Z'
  };

  const yearDigit = new Date().getFullYear().toString().at(-1);
  const [height, setHeight] = useState("0px");

  useEffect(() => {
    setLocalSymbol(dynamic_patch?.local_symbol || '');
    setMultiplier(dynamic_patch?.multiplier || '');
    setIsOpen(Boolean(dynamic_patch?.active));
  }, [dynamic_patch?.active, dynamic_patch?.local_symbol, dynamic_patch?.multiplier]);

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => { setHeight(`${contentRef.current?.scrollHeight}px`); }, 0);
      return () => clearTimeout(timer);
    } else {
      setHeight("0px");
    }
  }, [isOpen, showSymbols]);

  return (
    <div className={`max-w-sm mx-auto ${theme.cardBg} ${theme.cardRound} ${theme.cardBorder} p-5 mt-4`}>
      <button
        className={`p-3 ${isOpen ? "mb-4" : "mb-2"} w-full rounded-xl text-center text-sm font-semibold transition-all duration-200 ${isOpen ? theme.btnPrimary : theme.btnSecondary
          }`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? 'Hide' : 'Override Contract'}
      </button>
      <div ref={contentRef} style={{ maxHeight: height }} className="overflow-hidden transition-max-height duration-500 ease-in-out">
        <form>
          <div className="mb-4">
            <label htmlFor="localSymbol" className={`block text-xs font-semibold ${theme.textSecondary} mb-1 tracking-wide uppercase`}>Local Symbol</label>
            <button type="button" onClick={() => setShowSymbols(!showSymbols)} className={`text-xs text-olive-600 p-1 hover:bg-olive-50 rounded-lg mb-1 font-medium`}>
              {showSymbols ? '(hide list)' : '(see list of symbols)'}
            </button>
            <input type="text" id="localSymbol" value={localSymbol} placeholder="ex. PLQ5" onChange={(e) => setLocalSymbol(e.target.value)}
              className={`mt-1 block w-full px-3 py-2 text-sm ${theme.input}`} />
            {showSymbols && (
              <div className={`mt-2 ${theme.cardBorder} rounded-xl overflow-hidden`}>
                <table className={`min-w-full ${theme.sectionBg} text-xs`}>
                  <thead className={`${theme.tableHeader} border-b ${theme.tableBorder}`}>
                    <tr>
                      <th className={`px-3 py-2 text-left ${theme.tableHeadText} font-semibold uppercase tracking-wider`}>Month</th>
                      <th className={`px-3 py-2 text-left ${theme.tableHeadText} font-semibold uppercase tracking-wider`}>Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(contractMonths).map(([month, code]) => (
                      <tr key={month} className={`border-b border-olive-100 last:border-0 ${theme.tableRowHover} transition-colors`}>
                        <td className={`px-3 py-1.5 ${theme.textPrimary}`}>{month}</td>
                        <td className={`px-3 py-1.5 font-mono ${theme.textPrimary}`}>{`${symbol}${code}${yearDigit}`}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          <div className="mb-4">
            <label htmlFor="multiplier" className={`block text-xs font-semibold ${theme.textSecondary} mb-1 tracking-wide uppercase`}>Contract Multiplier</label>
            <input type="text" id="multiplier" value={multiplier} placeholder="ex. 1000 (optional)" onChange={(e) => setMultiplier(e.target.value)}
              className={`mt-1 block w-full px-3 py-2 text-sm ${theme.input}`} />
          </div>
          <button type="submit"
            className={`w-full px-4 py-2.5 rounded-xl text-sm font-semibold transition-all duration-200 active:scale-[0.98] ${dynamic_patch.active ? theme.btnDanger : theme.btnPrimary
              }`}
            onClick={handleSave}
          >
            {dynamic_patch.active ? "Disable" : "Enable"}
          </button>
        </form>
      </div>
      {dynamic_patch.active && (
        <div className="pt-3 text-center">
          <span className={`inline-block px-3 py-1 text-xs font-bold ${theme.badgeActive} rounded-lg uppercase tracking-wider`}>
            Contract Overridden
          </span>
        </div>
      )}
    </div>
  );
};

export default ConfigPatch;
